import { GameMode } from "../GameMode.js";
import { Ruleset } from "../Ruleset.js";
import { readJsonString } from "../../../util/json.js";


export interface QueueType {
    gameMode: GameMode;
    ruleset: Ruleset;
}


export function areQueueTypesEqual(type1: QueueType, type2: QueueType): boolean {
    return (type1.gameMode === type2.gameMode && type1.ruleset === type2.ruleset);
}


export function readJsonQueueType(json: Record<string, any>): QueueType {
    const gameMode: GameMode = GameMode.getByID(readJsonString(json, "queue_game_mode"));
    const ruleset: Ruleset = Ruleset.getByID(readJsonString(json, "queue_game_type"));
    return { gameMode, ruleset };
}
